/**
 * Export frame timing. Pure: frame i of an export is always stamped from its
 * index, never from the wall clock, so audio (stamped from sample index in
 * Phase 4) cannot drift against it.
 */

/** Exactly round(durationMs / 1000 * fps) frames. */
export function exportFrameCount(durationMs: number, fps: number): number {
  return Math.max(0, Math.round((durationMs / 1000) * fps));
}

/** Microseconds for frame `index` at `fps`. */
export function frameTimestampMicros(index: number, fps: number): number {
  return Math.round((index * 1e6) / fps);
}

/** Samples in a timeline of `durationMs`; the mixer renders exactly this many. */
export function audioSampleCount(durationMs: number, sampleRate: number): number {
  return Math.max(0, Math.ceil((durationMs / 1000) * sampleRate));
}

/** Microseconds for sample `index`: anchored at 0 like video, so the two cannot drift. */
export function audioTimestampMicros(sampleIndex: number, sampleRate: number): number {
  return Math.round((sampleIndex * 1e6) / sampleRate);
}

/** Number of samples whose timestamp is strictly before `micros`. */
export function samplesBefore(micros: number, sampleRate: number): number {
  return Math.max(0, Math.ceil((micros * sampleRate) / 1e6));
}
